module.exports = __webpack_public_path__ + "img/shadow_android_en.d2ebfb4.png";